import { IDiscriminator } from './interfaces';

/**
 * A typescript predicate that checks against a discriminator field named __typename
 * @param obj Should extend from IDiscriminator
 * @param discriminator Should match __typename = [Interface_Name] (match-casing)
 * @returns boolean
 */
export function isType<T extends IDiscriminator>(obj: unknown, discriminator: string): obj is T {
  const casted = (obj as T);
  return casted !== undefined && !!casted.__typename && casted.__typename === discriminator;
}